import { css } from 'lit';

export default css`
  :host {
    display: flex;
    flex: 1;
  }

  [part='wrapper'] {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: var(--sl-space-new-2xs);
    margin-inline: var(--sl-space-new-md);
  }

  slot[name='header'] .heading,
  slot[name='header']::slotted(*) {
    color: var(--sl-color-foreground-subtlest);
    padding: var(--sl-space-new-md);
    padding-inline-start: calc(
      var(--sl-menu-item-indent, 0) * (var(--sl-size-icon-sm) + var(--sl-space-new-md)) + var(--sl-space-new-md)
    );
  }
`;
